import { array, object, string } from 'yup';

import { AVAILABLE_START_TIME, AVAILABLE_END_TIME, PICKUP_CONTACT, PREFERRED_TIME, INSTRUCTIONS } from './constants';
import { formatTimeTo24Hour } from '../../../../services/time-helper-service';
import { twelveHourSettingForTimePicker } from '../../../../constants/timezone-format';

import messages from './messages';

const timeTo24HourPadded = (value) => formatTimeTo24Hour(value, twelveHourSettingForTimePicker);
const isAfterStartTime = (messageDescriptor) => (startTime, schema) =>
  schema.test('is-after-start-time', messageDescriptor, (value) => (value ? value > timeTo24HourPadded(startTime) : true));
const isBeforeEndTime = (messageDescriptor) => (endTime, schema) =>
  schema.test('is-before-end-time', messageDescriptor, (value) => (value ? value < timeTo24HourPadded(endTime) : true));

const startTimeSchema = string()
  .transform(timeTo24HourPadded)
  .when(AVAILABLE_END_TIME, isBeforeEndTime(messages.requireStartBeforeEndTime));

const endTimeSchema = string()
  .transform(timeTo24HourPadded)
  .when(AVAILABLE_START_TIME, isAfterStartTime(messages.requireEndAfterStartTime));

const preferredTimeSchema = string()
  .nullable()
  .notRequired()
  .transform(timeTo24HourPadded)
  .when(AVAILABLE_START_TIME, isAfterStartTime(messages.requirePreferredTimeAfterStartTime))
  .when(AVAILABLE_END_TIME, isBeforeEndTime(messages.requirePreferredTimeBeforeEndTime));

const pickupSettingsDaySchema = object().shape(
  {
    [PICKUP_CONTACT]: string().required(messages[PICKUP_CONTACT]),
    [AVAILABLE_START_TIME]: startTimeSchema.required(messages[AVAILABLE_START_TIME]),
    [AVAILABLE_END_TIME]: endTimeSchema.required(messages[AVAILABLE_END_TIME]),
    [PREFERRED_TIME]: preferredTimeSchema,
    [INSTRUCTIONS]: string().max(150, messages.instructionLength),
  },
  [AVAILABLE_START_TIME, AVAILABLE_END_TIME, PREFERRED_TIME],
);

const pickupSettingsSchema = array()
  .compact(({ isChecked }) => !isChecked) // filter out days that are not checked
  .of(pickupSettingsDaySchema)
  .min(1, messages.minRequiredNumberOfDays);

export default pickupSettingsSchema;
